import { Flex } from 'foundations-components/components/Flex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import { getFileTypeIcon } from '../constants/attachments';
import { IconButton } from 'foundations-components/transitional/components/IconButton';
import { DownloadIcon } from 'foundations-assets/icons/components/DownloadIcon';
import { HideIcon } from 'foundations-assets/icons/components/HideIcon';
import { WarningIcon } from 'foundations-assets/icons/components/WarningIcon';
import I18n from 'I18n';
import { downloadAttachment } from '../utils/downloadAttachment';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MessageAttachment = ({
  attachment,
  sensitiveAttachment,
  customSubtitle,
  inThread
}) => {
  const title = attachment ? attachment.fileMetadata.name : I18n.text('customer-portal-app.ticketThread.messageContent.attachment.errorTitle');
  const subtitle = sensitiveAttachment ? I18n.text('customer-portal-app.ticketThread.messageContent.attachment.sensitiveDescription') : attachment ? attachment.fileMetadata.type : I18n.text('customer-portal-app.ticketThread.messageContent.attachment.errorDescription');
  const FileIcon = attachment ? getFileTypeIcon({
    mimeType: attachment.fileMetadata.type,
    ext: attachment.fileMetadata.extension
  }) : WarningIcon;
  const handleDownload = () => {
    if (attachment) {
      void downloadAttachment(attachment.fileMetadata);
    }
  };
  const PreviewIcon = sensitiveAttachment ? HideIcon : FileIcon;
  return /*#__PURE__*/_jsxs(Flex, {
    borderWidth: "100",
    borderStyle: "solid",
    borderRadius: "400",
    borderColor: "border-core-subtle",
    padding: "200",
    alignItems: "center",
    justifyContent: "start",
    flexDirection: "row",
    inlineSize: inThread ? '240px' : '100%',
    minInlineSize: "240px",
    blockSize: "58px",
    gap: "400",
    children: [/*#__PURE__*/_jsx(Flex, {
      inlineSize: "40px",
      blockSize: "40px",
      borderRadius: "300",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: "fill-surface-recessed",
      children: /*#__PURE__*/_jsx(PreviewIcon, {
        size: "300"
      })
    }), /*#__PURE__*/_jsxs(Flex, {
      flexDirection: "column",
      gap: "100",
      flex: "1",
      minInlineSize: "0",
      children: [/*#__PURE__*/_jsx(Tooltip, {
        title: title,
        children: /*#__PURE__*/_jsx(View, {
          cursor: "pointer",
          children: /*#__PURE__*/_jsx(Text, {
            typography: "body-100",
            color: "text-core-default",
            truncate: true,
            children: title
          })
        })
      }), /*#__PURE__*/_jsx(Text, {
        typography: 'detail-100',
        color: 'text-core-default',
        truncate: true,
        children: customSubtitle || subtitle
      })]
    }), attachment && !sensitiveAttachment && /*#__PURE__*/_jsx(IconButton, {
      onClick: handleDownload,
      tooltip: I18n.text('customer-portal-app.ticketThread.messageContent.attachment.download'),
      use: "unstyled",
      children: /*#__PURE__*/_jsx(DownloadIcon, {
        size: "300",
        color: "icon-core-subtle"
      })
    })]
  });
};